import { render, staticRenderFns } from "./swipers-pagination.vue?vue&type=template&id=c7b99e84&scoped=true"
import script from "./swipers-pagination.vue?vue&type=script&lang=js"
export * from "./swipers-pagination.vue?vue&type=script&lang=js"
import style0 from "./swipers-pagination.vue?vue&type=style&index=0&id=c7b99e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b99e84",
  null
  
)

export default component.exports